import { position, rowScalar } from '../../encounter-map/ft3d/perception';
import { sizeIdOf } from '../../shared/array-types';
import { getSwarmTemplateForCreature } from '../../shared/swarm-templates';
import { creatureTokenGeometry, selectCreaturePicture } from '../../shared/creature-token-geometry';
import { SIZE_WIDTHS_FT } from '../inventory/lift-occupancy';
type Row=Record<string,unknown>;

export const FOOTPRINT_DEFINITION_NOT_HELD = 'swarmfootprint31:footprint-definition-not-held';

/** Resolve only held facts; the token renderer owns the stepped swarm geometry. */
export function creatureFootprint(row: Row, sizeId: unknown = sizeIdOf(row)) {
  const size = String(sizeId ?? '').toUpperCase();
  const base = SIZE_WIDTHS_FT[size];
  const swarm = getSwarmTemplateForCreature(row as never);
  if (!(base && base > 0) || (!swarm && rowScalar(row, 'swarm_width_lanes') != null)) {
    return { ok: false as const, reason: FOOTPRINT_DEFINITION_NOT_HELD };
  }
  const geometry = creatureTokenGeometry(row, selectCreaturePicture(row), undefined, size);
  return { ok: true as const, baseFt: base, widthFt: geometry.widthFt,
    depthFt: base, heightFt: geometry.heightFt };
}

/** The scene's box-edge distance, also used by speech on pages without a scene iframe. */
export function creatureBoxDistance(a:Row,b:Row,includeSwarm=false):number|null {
  const box=(row:Row):number[]|null=>{
    if(!includeSwarm && (rowScalar(row,'swarm_width_lanes')!=null || getSwarmTemplateForCreature(row as never)))return null;
    const footprint=creatureFootprint(row);
    if(!footprint.ok)return null;
    const {baseFt:base,widthFt:width,heightFt:height}=footprint,at=position(row);
    return [at.x-width/2,at.x+width/2,(at.y??0)-base/2,(at.y??0)+base/2,at.z-height/2,at.z+height/2];
  };
  const aa=box(a),bb=box(b);if(!aa||!bb)return null;
  return Math.hypot(...[0,2,4].map(i=>Math.max(0,bb[i]!-aa[i+1]!,aa[i]!-bb[i+1]!)));
}
